export default "__VITE_ASSET__8e158f1d__"